/*
  F09 - predictive search (2026-08-13). Progressive enhancement for the theme's
  /search form (sections/main-search.liquid; the header links to /search).
  Powered by Shopify's suggest endpoint; no libraries. Without JS the form
  submits normally - the form's action/method are never touched.
  Styles live in assets/audit-fixes.css (.pred-search__*).
*/
(function () {
  'use strict';

  var uid = 0;

  function formatMoney(amount) {
    var fmt = window.JamilahMoneyFormat;
    if (typeof fmt !== 'string' || fmt.indexOf('{{') === -1) return '$' + amount;
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, amount);
  }

  function thumb(url) {
    /* Shopify CDN resize param keeps the request tiny. */
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=88';
  }

  function setup(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || form.hasAttribute('data-pred-search')) return;
    form.setAttribute('data-pred-search', '');
    form.classList.add('pred-search');
    form.setAttribute('aria-expanded', 'false');

    var panel = document.createElement('div');
    panel.className = 'pred-search__panel';
    panel.id = 'PredSearchPanel-' + (++uid);
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Search suggestions');
    panel.hidden = true;
    form.appendChild(panel);

    var timer = null;
    var lastQuery = '';
    var controller = null;

    function open() {
      panel.hidden = false;
      form.setAttribute('aria-expanded', 'true');
    }
    function close() {
      panel.hidden = true;
      form.setAttribute('aria-expanded', 'false');
    }

    function heading(text) {
      var el = document.createElement('div');
      el.className = 'pred-search__group';
      el.setAttribute('role', 'presentation');
      el.textContent = text;
      return el;
    }
    function item(href, extraClass) {
      var a = document.createElement('a');
      a.className = 'pred-search__item' + (extraClass ? ' ' + extraClass : '');
      a.href = href;
      a.setAttribute('role', 'option');
      return a;
    }
    function titleSpan(text) {
      var s = document.createElement('span');
      s.className = 'pred-search__title';
      s.textContent = text;
      return s;
    }

    function render(q, results) {
      var products = results.products || [];
      var articles = results.articles || [];
      var pages = results.pages || [];
      panel.textContent = '';

      if (!products.length && !articles.length && !pages.length) {
        close();
        return;
      }

      if (products.length) {
        panel.appendChild(heading('Products'));
        products.forEach(function (p) {
          var a = item(p.url);
          if (p.featured_image && p.featured_image.url) {
            var img = document.createElement('img');
            img.className = 'pred-search__thumb';
            img.src = thumb(p.featured_image.url);
            img.alt = '';
            img.loading = 'lazy';
            img.width = 44;
            img.height = 44;
            a.appendChild(img);
          } else {
            var ph = document.createElement('span');
            ph.className = 'pred-search__thumb';
            a.appendChild(ph);
          }
          a.appendChild(titleSpan(p.title));
          if (p.price) {
            var price = document.createElement('span');
            price.className = 'pred-search__price';
            price.textContent = formatMoney(p.price);
            a.appendChild(price);
          }
          panel.appendChild(a);
        });
      }

      if (articles.length || pages.length) {
        panel.appendChild(heading('Guides & articles'));
        articles.concat(pages).forEach(function (r) {
          var a = item(r.url);
          a.appendChild(titleSpan(r.title));
          panel.appendChild(a);
        });
      }

      var all = item('/search?q=' + encodeURIComponent(q), 'pred-search__all');
      all.appendChild(titleSpan("See all results for '" + q + "'"));
      panel.appendChild(all);

      open();
    }

    function fetchSuggestions(q) {
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,article,page' +
        '&resources[limit]=4' +
        '&resources[options][unavailable_products]=hide';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || input.value.trim() !== q) return;
          var results = (data.resources && data.resources.results) || {};
          render(q, results);
        })
        .catch(function () { /* network/abort: leave the form working as-is */ });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (timer) clearTimeout(timer);
      if (q.length < 2) {
        lastQuery = '';
        close();
        return;
      }
      timer = setTimeout(function () {
        if (q === lastQuery) {
          if (panel.childNodes.length) open();
          return;
        }
        lastQuery = q;
        fetchSuggestions(q);
      }, 250);
    });

    input.addEventListener('focus', function () {
      if (panel.hidden && panel.childNodes.length && input.value.trim().length >= 2) open();
    });

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') close();
    });

    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element) || !e.target.closest('[data-pred-search]')) close();
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[role="search"], form[action*="/search"]');
    Array.prototype.forEach.call(forms, function (form) {
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/search') !== -1) setup(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
